import React from 'react';
import '../css/PracticalApproach.css';

const PracticalApproach = () => {
  const trainingPillars = [
    { id: 1, icon: "🔥", text: "Fire Safety Demonstrations" },
    { id: 2, icon: "🔍", text: "Workplace Hazard Identification" },
    { id: 3, icon: "📋", text: "Risk Assessment Exercises" },
    { id: 4, icon: "🛠️", text: "Safety Equipment Handling" },
    { id: 5, icon: "🚑", text: "Emergency Response Awareness" },
    { id: 6, icon: "🦺", text: "Industrial Safety Practices" }
  ];

  return (
    <section className="gfi-practical-section">
      <div className="gfi-practical-container">
        
        <div className="gfi-practical-mesh-grid">
          
          {/* LEFT PANEL: DRILL OPERATION LIVE COMPOSITE CANVAS */}
          <div className="gfi-prac-left-column">
            <div className="gfi-prac-image-canvas">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=600&auto=format&fit=crop" 
                alt="Greenfield Industrial Fire and Safety Academy Real-World Practical Factory Drills First Aid Simulations" 
                className="gfi-prac-drill-img"
              />
            </div>
          </div>

          {/* RIGHT PANEL: TYPOGRAPHY AND ACCENTED SKILLS GRID */}
          <div className="gfi-prac-right-column">
            <span className="gfi-prac-upper-label">REAL-WORLD SKILLS</span>
            <h2 className="gfi-prac-main-title">Practical Training Approach</h2>
            <p className="gfi-prac-summary-para">
              Greenfield Academy emphasizes practical learning through hands-on exercises and real-world simulations.
            </p>

            {/* 2-COLUMN ACCENTED PILL CARDS GRID */}
            <div className="gfi-prac-pillars-grid">
              {trainingPillars.map((pillar) => (
                <div key={pillar.id} className="gfi-prac-pillar-accent-card">
                  {/* Left Solid Border Accent Line is handled purely via CSS pseudo-element */}
                  <div className="gfi-prac-card-content-pack">
                    <span className="gfi-prac-pillar-icon">{pillar.icon}</span>
                    <span className="gfi-prac-pillar-text">{pillar.text}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* BOTTOM SUCCESS HIGHLIGHT STRIP BANNER */}
            <div className="gfi-prac-outcome-success-strip">
              <div className="gfi-prac-strip-inner-flex">
                <span className="gfi-prac-bulb-icon">💡</span>
                <p className="gfi-prac-strip-statement-txt">
                  Our practical training approach helps students improve workplace understanding and professional confidence.
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default PracticalApproach;